import React, { Component } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Link } from "react-router-dom";
const plus = require("../assets/plus.png");
const device = require("../assets/qr.png");
const history = require("../assets/icons/clock.png");
const imei = require("../assets/imei.png");

export class Enroll extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  webMenuDynamic = () => {
    console.log("calling", "webMenuDynamic");

    let imageMap = {
      "/enrollment": plus,
      "/qr-registration": device,
      "/imei-upload": imei,
      "/enrollment-history": history,
    };

    return (
      this.props.extraProp !== null &&
      this.props.extraProp !== undefined &&
      this.props.extraProp.map((e, v) => {
        if (e.feature.category === 0) {
          if (e.feature.title !== "Dashboard") {
            let helpingMenu = imageMap[e.feature.protectedUrl];
            let icon =
              helpingMenu !== undefined ? helpingMenu : "pi pi-fw pi-dollar";
            return (
              <div key={"mo-" + v} className="p-col-12 p-md-3 p-xl-3 p-sm-6">
                <div key={"ch1-" + v} className="small-box bg-aqua">
                  <div key={"ch11-" + v} className="icon">
                    <img
                      src={icon}
                      width="60px"
                      style={{ width: "60px", height: "60px" }}
                      className="mx-auto d-block"
                    />
                    {/* <i
                      className={icon + " " + "mx-auto d-block"}
                      style={{
                        width: "60px",
                        height: "60px",
                        color: "#ffffff",
                        fontSize: "3.5em",
                      }}
                    ></i> */}
                  </div>
                  <Link
                    to={e.feature.protectedUrl}
                    className="small-box-footer"
                  >
                    {e.feature.title}
                  </Link>
                </div>
              </div>
            );
          }
        }
      })
    );
  };

  render() {
    const items = [{ label: "Dashboard", url: "/dashboard" }, { label: "Enroll" }];

    const home = { icon: "pi pi-home", url: "/dashboard" };
    return (
      <div className="p-grid p-fluid dashboard">
        <div className="p-col-12 p-lg-12">
          <div className="content-section implementation">
            <BreadCrumb model={items} home={home} />
          </div>
        </div>
        {this.props.extraProp !== undefined && this.webMenuDynamic()}
        {/* <div className="p-col-12 p-md-3 p-xl-3 p-sm-6">
          <div className="small-box bg-aqua">
            <div className="icon">
              <img
                alt="Enroll"
                src={plus}
                width="60px"
                style={{ width: "60px", height: "60px" }}
                className="mx-auto d-block"
              />
            </div>
            <Link to="/enrollment" className="small-box-footer">
              ENROLLMENT SETTINGS
            </Link>
          </div>
        </div>
        <div className="p-col-12 p-md-3 p-xl-3 p-sm-6">
          <div className="small-box bg-aqua">
            <div className="icon">
              <img
                alt="Enroll"
                src={device}
                width="60px"
                style={{ width: "60px", height: "60px" }}
                className="mx-auto d-block"
              />
            </div>
            <Link to="/QrRegistration" className="small-box-footer">
              QR REGISTRATION
            </Link>
          </div>
        </div>
        <div className="p-col-12 p-md-3 p-xl-3 p-sm-6">
          <div className="small-box bg-aqua">
            <div className="icon">
              <img
                src={history}
                width="60px"
                style={{ width: "60px", height: "60px" }}
                className="mx-auto d-block"
              />
            </div>
            <Link to="/enrollment-history" className="small-box-footer">
              Enrollment History
            </Link>
          </div>
        </div> */}
      </div>
    );
  }
}
